export default __webpack_public_path__ + "static/media/loansharklogo.18b93f1f.png";